<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container-xl">
          <section class="section-prices">
            <div class="lds-ring" v-if="!isLoad">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <form v-if="isLoad">
              <div class="page-title page-title_price">
                <h2>Climbing Cost for Client</h2>
                <div class="page-title__side">
                  <!--options-include start-->
                  <div v-if="true" class="options-include-price">
                    <label class="form-control-checkbox" @click.prevent="includeHotelsAndTransfers = !includeHotelsAndTransfers; findIncludeHotelsAndTransfers()">
                      <input type="checkbox" :checked="includeHotelsAndTransfers"/>
                      <span class="form-control-checkbox__box">
                              <svg width="1em" height="1em" class="icon icon-check">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                              </svg>
                            </span>
                      <span class="form-control-checkbox__name">Hotels & transfers included</span>
                    </label>
                  </div>
                  <!--options-include end-->
                  <div class="switcher-el  switcher-el_prices">
                    <a href="#" :class="['switcher-el__item', {'active' : tab === 'CLASSIC'}]" @click="tab = 'CLASSIC'">
                      <svg width="1em" height="1em" class="icon icon-star">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                      </svg>
                      <svg width="1em" height="1em" class="icon icon-star">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                      </svg>
                      <svg width="1em" height="1em" class="icon icon-star">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                      </svg>
                      <svg width="1em" height="1em" class="icon icon-star">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                      </svg>
                      <span class="switcher-el__text">Classic</span>
                    </a>
                    <a href="#" :class="['switcher-el__item', {'active' : tab === 'PREMIUM'}]" @click="tab = 'PREMIUM'">
                      <svg width="1em" height="1em" class="icon icon-star">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                      </svg>
                      <svg width="1em" height="1em" class="icon icon-star">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                      </svg>
                      <svg width="1em" height="1em" class="icon icon-star">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                      </svg>
                      <svg width="1em" height="1em" class="icon icon-star">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                      </svg>
                      <svg width="1em" height="1em" class="icon icon-star">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                      </svg>
                      <span class="switcher-el__text">Premium</span>
                    </a>
                  </div>
                  <div class="form-control-group">
                    <div class="page-title__side">
                      <span class="label-year">Year:</span>
                      <div :class="['select-wrapper select-wrapper--sm select-wrapper_year-sm', {'is-active' : yearSelect}]"
                           @click="yearSelect = !yearSelect">
                        <div class="select-trigger"><span
                            class="select-trigger__name">{{ years.find(item => item.active).name }}</span><span
                            class="select-trigger__icon">
                            <svg width="1em" height="1em" class="icon icon-chevron ">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg></span></div>
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <div
                                v-for="item in years"
                                :key="item.name"
                                :class="['select-option', {'is-selected' : item.active}]"
                                @click="years = years.map(year => ({...year, active: item.name === year.name}))"><span
                                class="select-option__name">{{ item.name }}</span></div>
                          </div>
                        </div>
                      </div>
                      <button
                          type="button"
                          class="btn btn--green btn--sm-squared btn--popover"
                          data-popover="Copy rates from the previous year"
                          @click="copyPopup = true"
                      >
                        <svg width="1em" height="1em" class="icon icon-copy ">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                        </svg>
                      </button>
                    </div>

                  </div>
                </div>
              </div>
              <div class="prices-wrap">
                <div class="prices-table-wrap">
                  <div data-simplebar="data-simplebar" class="section-table-wrap">
                    <table class="default-table prices-table js-table-column-hover">
                      <thead>
                      <tr>
                        <th class="default-table__th default-table__th-title"><span>Program</span></th>
                        <th class="default-table__th"><span>1 Pax</span></th>
                        <th class="default-table__th"><span>2 Pax</span></th>
                        <th class="default-table__th"><span>3 Pax</span></th>
                        <th class="default-table__th"><span>4 Pax</span></th>
                        <th class="default-table__th"><span>5 Pax</span></th>
                        <th class="default-table__th"><span>6 Pax</span></th>
                        <th class="default-table__th"><span>7 Pax</span></th>
                        <th class="default-table__th"><span>8 Pax</span></th>
                        <th class="default-table__th default-table__td-total"><span>Tour Leader</span></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in costsData" :key="item.routeId">
                        <td class="default-table__th-title">
                          <span>{{ item.routeName }} {{ item.routeDurationDays }} Days</span>
                        </td>
                        <td class="default-table__td" @click="isEdit = true">
                          <the-mask type="text" v-model="item.pax1" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.pax2" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.pax3" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.pax4" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.pax5" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.pax6" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.pax7" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.pax8" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true" class="default-table__th default-table__td-total">
                          <the-mask type="text" v-model="item.tourLeader" :tokens="{'#': {pattern: /[\d]?/}}"
                                    :mask="['$######']"/>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="table-save-btn">
                  <button type="button" class="btn btn--green" @click="updateClimbingCostsHandler"><span>Save</span>
                  </button>
                </div>
              </div>

              <div class="page-title page-title--mt">
                <h2>Climbing Cost for Tour Leader</h2>
              </div>
              <div class="prices-wrap prices-wrap--tourleader">
                <div class="prices-table-wrap">
                  <div data-simplebar="data-simplebar" class="section-table-wrap">
                    <table class="default-table prices-table js-table-column-hover">
                      <thead>
                      <tr>
                        <th class="default-table__th default-table__th-title">
                          <span>Program</span>
                          <span class="default-table__th-add">
                            <span>Prices.</span>
                            Price per a Tour leader depend on the group size
                          </span>
                        </th>
                        <th class="default-table__th"><span>1 Pax</span></th>
                        <th class="default-table__th"><span>2 Pax</span></th>
                        <th class="default-table__th"><span>3 Pax</span></th>
                        <th class="default-table__th"><span>4 Pax</span></th>
                        <th class="default-table__th"><span>5 Pax</span></th>
                        <th class="default-table__th"><span>6 Pax</span></th>
                        <th class="default-table__th"><span>7 Pax</span></th>
                        <th class="default-table__th"><span>8 Pax</span></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in tourLeaderData" :key="item.routeId">
                        <td class="default-table__th-title">
                          <span>{{ item.routeName }} {{ item.routeDurationDays }} Days</span>
                        </td>
                        <td class="default-table__td" @click="isEdit = true">
                          <the-mask type="text" v-model="item.pax1" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.pax2" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.pax3" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.pax4" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.pax5" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.pax6" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.pax7" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.pax8" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="table-save-btn">
                  <button type="button" class="btn btn--green" @click="updateClimbingTourLeaderHandler"><span>Save</span>
                  </button>
                </div>
              </div>

              <div class="prices-wrap">
                <div class="prices-heading">
                  <div class="prices-heading__icon">
                    <svg width="1em" height="1em" class="icon icon-precent">
                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-percent"></use>
                    </svg>
                  </div>
                  <h2>DISCOUNT</h2>
                  <span class="form-control__help form-control__help-offset">
                      <span class="form-control__help-icon">
                        <span class="form-control__help-content">Подробнее читайте в нашем <a href="#">FAQ</a></span>
                        <img src="/images/useful/svg/help-icon.svg" alt="">
                      </span>
                    </span>
                </div>
                <div class="prices-table-wrap">
                  <div data-simplebar="data-simplebar" class="section-table-wrap">
                    <table class="default-table prices-table prices-table-2 js-table-column-hover">
                      <thead>
                      <tr>
                        <th class="default-table__th default-table__th-title"><span>Program</span></th>
                        <th class="default-table__th"><span>Adult (EA)</span></th>
                        <th class="default-table__th"><span>Adult (Res)</span></th>
                        <th class="default-table__th"><span>Teenager (Foreign)</span></th>
                        <th class="default-table__th"><span>Teenager (EA)</span></th>
                        <th class="default-table__th"><span>Teenager (Res)</span></th>
                      </tr>
                      </thead>
                      <tbody>

                      <tr v-for="item in discountsData" :key="item.routeId">
                        <td class="default-table__th-title">
                          <span>{{ item.routeName }} {{ item.routeDurationDays }} Days</span>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.adultEA" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.adultRes" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.teenagerForeign" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.teenagerEA" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                        <td @click="isEdit = true">
                          <the-mask type="text" v-model="item.teenagerRes" :tokens="{'#': {pattern: /[\d]/}}"
                                    :mask="['$######']"/>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="table-save-btn">
                  <button type="button" class="btn btn--green" @click="updateClimbingDiscountsHandler"><span>Save</span>
                  </button>
                </div>
              </div>
              <div class="prices-wrap" v-if="details.details">
                <div class="languages-group">
                  <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                         @click="activeDetail = 'EN'">
                    <input type="radio" name="lanuage" :checked="activeDetail === 'EN'">
                    <div class="np-detail-collapse__lang__icon">
                      <svg width="1em" height="1em" class="icon icon-gb ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                      </svg>
                    </div>
                    <span class="np-detail-collapse__lang__text">English</span>
                  </label>
                  <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                         @click="activeDetail = 'RU'">
                    <input type="radio" name="lanuage" :checked="activeDetail === 'RU'">
                    <div class="np-detail-collapse__lang__icon">
                      <svg width="1em" height="1em" class="icon icon-rus ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                      </svg>
                    </div>
                    <span class="np-detail-collapse__lang__text">Russian</span>
                  </label>
                  <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                         @click="activeDetail = 'DE'">
                    <input type="radio" name="lanuage" :checked="activeDetail === 'DE'">
                    <div class="np-detail-collapse__lang__icon">
                      <svg width="1em" height="1em" class="icon icon-deu ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-deu"></use>
                      </svg>
                    </div>
                    <span class="np-detail-collapse__lang__text">Deutch</span>
                  </label>
                </div>
                <div class="text-edit-price-wrapper">
                  <div class="text-edit-price">
                    <div class="text-edit-price__item">
                      <div class="text-edit-price__head">
                          <span class="text-edit-price__head-icon">
                            <svg width="1em" height="1em" class="icon icon-check ">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                            </svg>
                          </span>
                        Inclusions
                      </div>
                      <div class="form-control-wrap">
                        <div class="text-heading">Transfers:</div>
                        <div class="text-edit-price__text">
                          <div class="js-ckeditor">
                            <editor @input="isEdit = true" :editor="editor"
                                    v-model="details.details[activeDetail].inclusion.transfers"
                                    :config="editorConfig"></editor>
                          </div>
                        </div>
                        <div class="text-heading">Entry fees:</div>
                        <div class="text-edit-price__text">
                          <div class="js-ckeditor">
                            <editor @input="isEdit = true" :editor="editor"
                                    v-model="details.details[activeDetail].inclusion.entryFees"
                                    :config="editorConfig"></editor>
                          </div>
                        </div>
                        <div class="text-heading">Accommodation:</div>
                        <div class="text-edit-price__text">
                          <div class="js-ckeditor">
                            <editor @input="isEdit = true" :editor="editor"
                                    v-model="details.details[activeDetail].inclusion.accommodations"
                                    :config="editorConfig"></editor>
                          </div>
                        </div>
                        <div class="text-heading">Meals:</div>
                        <div class="text-edit-price__text">
                          <div class="js-ckeditor">
                            <editor @input="isEdit = true" :editor="editor"
                                    v-model="details.details[activeDetail].inclusion.meals"
                                    :config="editorConfig"></editor>
                          </div>
                        </div>
                        <div class="text-heading">Hiking and safety equipment:</div>
                        <div class="text-edit-price__text">
                          <div class="js-ckeditor">
                            <editor @input="isEdit = true" :editor="editor"
                                    v-model="details.details[activeDetail].inclusion.hiking"
                                    :config="editorConfig"></editor>
                          </div>
                        </div>
                        <div class="text-heading">Climbing crew:</div>
                        <div class="text-edit-price__text">
                          <div class="js-ckeditor">
                            <editor @input="isEdit = true" :editor="editor"
                                    v-model="details.details[activeDetail].inclusion.climbingCrew"
                                    :config="editorConfig"></editor>
                          </div>
                        </div>
                        <div class="text-heading">Taxes:</div>
                        <div class="text-edit-price__text">
                          <div class="js-ckeditor">
                            <editor @input="isEdit = true" :editor="editor"
                                    v-model="details.details[activeDetail].inclusion.taxes"
                                    :config="editorConfig"></editor>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="text-edit-price__item">
                      <div class="text-edit-price__head">
                          <span class="text-edit-price__head-icon">
                            <svg width="1em" height="1em" class="icon icon-close ">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                            </svg>
                          </span>
                        Exclusions
                      </div>
                      <div class="form-control-wrap">
                        <div class="js-ckeditor">
                          <editor @input="isEdit = true" :editor="editor"
                                  v-model="details.details[activeDetail].exclusion" :config="editorConfig2"></editor>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="table-save-btn">
                  <button type="button" class="btn btn--green" @click="updateClimbingDetailsHandler"><span>Save</span>
                  </button>
                </div>
              </div>

            </form>
            <div class="modal-wrapper" v-if="copyPopup">
              <div class="modal-backdrop"></div>
              <div class="modal-inner">
                <div class="edit-popup edit-popup--copy-md">
                  <div class="edit-popup__header">
                    <div class="edit-popup__title">
                      <div class="edit-popup__title__icon">
                        <svg width="1em" height="1em" class="icon icon-recover">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                        </svg>
                      </div>
                      <span>Copy from another year</span>
                    </div>
                    <div class="edit-popup__close" @click="copyPopup = false">
                      <svg width="1em" height="1em" class="icon icon-close ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                      </svg>
                    </div>
                  </div>
                  <form action="javascript:void(0)" class="edit-popup__inner">
                    <div class="edit-popup__form-2">
                      <div class="form-control-group"><span class="form-control-label">Choose year</span>
                        <div :class="['select-wrapper', { 'is-active' : copyPopupOpen }]"
                             @click="copyPopupOpen = !copyPopupOpen">
                          <div class="select-trigger"><span
                              class="select-trigger__name">{{ copyPopupFrom }}</span><span
                              class="select-trigger__icon">
										<svg width="1em" height="1em" class="icon icon-chevron ">
										<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
										</svg></span></div>
                          <div class="select-body">
                            <div class="select-inner js-scrollbar">
                              <div v-for="(y, index) in years.filter(y => !(y === copyPopup))" :key="index"
                                   :class="['select-option', { 'is-selected' : copyPopupFrom === y.name }]"
                                   @click="copyPopupFrom = y.name"><span class="select-option__name">{{ y.name }}</span></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button type="submit" class="btn btn--green edit-popup__submit-2"
                              @click="copyYearOldHandler();copyPopup = false">
                        <svg width="1em" height="1em" class="icon icon-recover">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                        </svg>
                        <span>Copy</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>


<script>

import {
  getClimbingCosts,
  updateClimbingCosts,
  getClimbingDetails,
  updateClimbingDetails,
  getClimbingDiscounts,
  updateClimbingDiscounts,
  getClimbingTourLeader,
  updateClimbingTourLeader,
} from '@/utilites/api'
import {TheMask} from 'vue-the-mask'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@/utilites/ckeditor'

export default {
  data() {
    return {
      includeHotelsAndTransfers: true,
      fromNationalPark: true,
      copyPopup: false,
      copyPopupOpen: false,
      copyPopupFrom: '',
      editor: ClassicEditor,
      editorConfig: {
        placeholder: 'Description'
      },
      editorConfig2: {
        placeholder: 'Exclusions'
      },
      costs: {},
      tourLeader: {},
      details: {
        details: {
          EN: {
            inclusion: {
              "transfers": "",
              "entryFees": "",
              "accommodations": "",
              "meals": "",
              "hiking": "",
              "climbingCrew": ""
            }, exclusion: ''
          }, RU: {
            inclusion: {
              "transfers": "",
              "entryFees": "",
              "accommodations": "",
              "meals": "",
              "hiking": "",
              "climbingCrew": ""
            }, exclusion: ''
          }, DE: {
            inclusion: {
              "transfers": "",
              "entryFees": "",
              "accommodations": "",
              "meals": "",
              "hiking": "",
              "climbingCrew": ""
            }, exclusion: ''
          }
        }
      },
      discounts: {},
      activeDetail: 'EN',
      tab: 'CLASSIC',
      isLoad: false,
      yearSelect: false,
      isEdit: false,
      costsData: [],
      discountsData: [],
      tourLeaderData: [],
      years: [
        {
          name: 2021,
          active: true
        },
        {
          name: 2022,
          active: false
        },
        {
          name: 2023,
          active: false
        },
        {
          name: 2024,
          active: false
        },
        {
          name: 2025,
          active: false
        },
        {
          name: 2026,
          active: false
        },
        {
          name: 2027,
          active: false
        },
        {
          name: 2028,
          active: false
        },
        {
          name: 2029,
          active: false
        },
        {
          name: 2030,
          active: false
        }
      ]
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEdit) {
      this.$emit('notLeaveHandler')
    }
    next()
  },
  beforeCreate() {
    document.title = 'Climbing / Prices'
  },
  components: {editor: CKEditor.component, TheMask},
  props: ['user'],
  mounted() {
    document.title = 'Climbing / Prices'
    Promise.allSettled(
      [
        getClimbingCosts(this.user.access_token, this.years.find(item => item.active).name, this.includeHotelsAndTransfers),
        getClimbingDetails(this.user.access_token, 'CLASSIC'),
        getClimbingDiscounts(this.user.access_token),
        getClimbingTourLeader(this.years.find(item => item.active).name, this.includeHotelsAndTransfers)
      ])
        .then(res => {
          this.isLoad = true
          this.costs = res[0].status === "fulfilled" ? res[0].value : this.costs
          this.details = res[1].status === "fulfilled" ? res[1].value : this.details
          this.discounts = res[2].status === "fulfilled" ? res[2].value : this.discounts
          this.tourLeader = res[3].status === "fulfilled" ? res[3].value.data : this.tourLeader
        })
    window.addEventListener('click', event => {
      if (!event.target.closest('.select-wrapper')) {
        this.yearSelect = false
      }
    })
  },
  methods: {
    findIncludeHotelsAndTransfers(){
      getClimbingCosts(this.user.access_token, this.years.find(item => item.active).name, this.includeHotelsAndTransfers)
          .then(res => {
            this.costs = res
          })
      getClimbingTourLeader(this.years.find(item => item.active).name, this.includeHotelsAndTransfers)
          .then(res => {
            this.tourLeader = res.data
          })
    },
    copyYearOldHandler() {
      Promise.allSettled(
        [
          getClimbingCosts(this.user.access_token, this.copyPopupFrom, this.includeHotelsAndTransfers),
          getClimbingDetails(this.user.access_token, 'CLASSIC'),
          getClimbingDiscounts(this.user.access_token),
          getClimbingTourLeader(this.copyPopupFrom, this.includeHotelsAndTransfers)
        ])
          .then(res => {
            this.isLoad = true
            this.costs = res[0].status === "fulfilled" ? res[0].value : this.costs
            this.details = res[1].status === "fulfilled" ? res[1].value : this.details
            this.discounts = res[2].status === "fulfilled" ? res[2].value : this.discounts
            this.tourLeader = res[3].status === "fulfilled" ? res[3].value.data : this.tourLeader
          })
    },
    updateClimbingCostsHandler() {
      updateClimbingCosts(this.user.access_token, this.includeHotelsAndTransfers, this.costs[this.tab].map(item => ({
        "routeId": item.routeId,
        "type": item.type,
        "pax1": item.pax1,
        "pax2": item.pax2,
        "pax3": item.pax3,
        "pax4": item.pax4,
        "pax5": item.pax5,
        "pax6": item.pax6,
        "pax7": item.pax7,
        "pax8": item.pax8,
        "tourLeader": item.tourLeader
      })), this.years.find(item => item.active).name)
          .then(() => {
            this.$emit('confirmed')
            this.isEdit = false
          })
    },
    updateClimbingTourLeaderHandler() {
      updateClimbingTourLeader(this.includeHotelsAndTransfers, this.tourLeader[this.tab].map(item => ({
        "routeId": item.routeId,
        "type": item.type,
        "pax1": item.pax1,
        "pax2": item.pax2,
        "pax3": item.pax3,
        "pax4": item.pax4,
        "pax5": item.pax5,
        "pax6": item.pax6,
        "pax7": item.pax7,
        "pax8": item.pax8,
      })), this.years.find(item => item.active).name)
        .then(() => {
          this.$emit('confirmed')
          this.isEdit = false
        })
    },
    updateClimbingDiscountsHandler() {
      updateClimbingDiscounts(this.user.access_token, this.discounts[this.tab].map(item => ({
        "routeId": item.routeId,
        "type": item.type,
        "adultEA": item.adultEA,
        "adultRes": item.adultRes,
        "teenagerForeign": item.teenagerForeign,
        "teenagerEA": item.teenagerEA,
        "teenagerRes": item.teenagerRes,
      })))
          .then(() => {
            this.$emit('confirmed')
            this.isEdit = false
          })
    },
    updateClimbingDetailsHandler() {
      updateClimbingDetails(this.user.access_token, {details: this.details.details, type: this.tab})
          .then(() => {
            this.$emit('confirmed')
            this.isEdit = false
          })
    }
  },
  watch: {
    tab() {
      this.isLoad = false
      getClimbingDetails(this.user.access_token, this.tab)
          .then(res => {
            this.details = res
            this.isLoad = true
          })
          .catch(() => {
            this.details = {
              details: {
                EN: {
                  inclusion: {
                    "transfers": "",
                    "entryFees": "",
                    "accommodations": "",
                    "meals": "",
                    "hiking": "",
                    "climbingCrew": ""
                  }, exclusion: ''
                }, RU: {
                  inclusion: {
                    "transfers": "",
                    "entryFees": "",
                    "accommodations": "",
                    "meals": "",
                    "hiking": "",
                    "climbingCrew": ""
                  }, exclusion: ''
                }, DE: {
                  inclusion: {
                    "transfers": "",
                    "entryFees": "",
                    "accommodations": "",
                    "meals": "",
                    "hiking": "",
                    "climbingCrew": ""
                  }, exclusion: ''
                }
              }
            }
            this.isLoad = true
          })
      this.costsData = this.costs[this.tab].sort((a, b) => a.routeName.toLowerCase() < b.routeName.toLowerCase() ? -1 : 1)
      this.discountsData = this.discounts[this.tab].sort((a, b) => a.routeName.toLowerCase() < b.routeName.toLowerCase() ? -1 : 1)
      this.tourLeaderData = this.tourLeader[this.tab].sort((a, b) => a.routeName.toLowerCase() < b.routeName.toLowerCase() ? -1 : 1)
    },
    years() {
      getClimbingCosts(this.user.access_token, this.years.find(item => item.active).name, this.includeHotelsAndTransfers)
          .then(res => {
            this.costs = res
          })
      getClimbingTourLeader(this.years.find(item => item.active).name, this.includeHotelsAndTransfers)
        .then(res => {
          this.tourLeader = res.data
        })
    },
    costs() {
      this.costsData = this.costs[this.tab].sort((a, b) => a.routeName.toLowerCase() < b.routeName.toLowerCase() ? -1 : 1)
    },
    tourLeader() {
      this.tourLeaderData = this.tourLeader[this.tab].sort((a, b) => a.routeName.toLowerCase() < b.routeName.toLowerCase() ? -1 : 1)
    },
    discounts() {
      this.discountsData = this.discounts[this.tab].sort((a, b) => a.routeName.toLowerCase() < b.routeName.toLowerCase() ? -1 : 1)
    }
  }
}
</script>
